import { createSlice } from "@reduxjs/toolkit";

export const bugSlice = createSlice({
  name: "bugDetails",

  initialState: {
    isBugPage: false,

    isBugSummaryModal: false,
    bugSummary: [],

    selectedBugSummary: {},

    selectedProject: {},

    selectedProjectBugs: [],

    isBugDashboard: false,

    bugViewMode: false,

    currentBugDetails: [],
    
    loading:false
  },

  reducers: {
    setCurrentBugDetails(state, action) {
      state.currentBugDetails = action.payload;
    },

    setIsBugPage(state, action) {
      state.isBugPage = action.payload;
    },
    setBugViewMode(state, action) {
      state.bugViewMode = action.payload;
    },

    setIsBugSummaryModal(state, action) {
      state.isBugSummaryModal = action.payload;
    },

    setBugSummary(state, action) {
      state.bugSummary = action.payload;
    },

    setSelectedBugSummary(state, action) {
      state.selectedBugSummary = action.payload;
    },

    setSelectedProject(state, action) {
      state.selectedProject = action.payload;
    },

    setSelectedProjectBugs(state, action) {
      state.selectedProjectBugs = action.payload;
    },

    setIsBugDashboard(state, action) {
      state.isBugDashboard = action.payload;
    },
    
    setLoading(state, action){
      state.loading = action.payload;
    }
  },
});

export const {
  setIsBugPage,
  setIsBugSummaryModal,
  setBugSummary,
  setSelectedBugSummary,
  setSelectedProject,
  setSelectedProjectBugs,
  setIsBugDashboard,
  setBugViewMode,
  setCurrentBugDetails,
  setLoading
} = bugSlice.actions;
